module.exports = __webpack_public_path__ + "img/P150T_weapon_23.03101a9f.png";